export const selectFriendProfile = (state) =>
  state.view_friends?.selectedFriend;

export const friendTransferLoading = (state) =>
  state.view_friends?.pendingTransfer.isLoading;
